/**
 * CardCheckoutPanel styles — CWR 2.6.
 *
 * The Express Checkout Element (wallets) and Payment Element render their own
 * Stripe-owned iframes (themed via the Appearance API), so the panel only styles
 * the chrome between them: the "or pay with card" divider, the loading skeleton,
 * and an inline intent error. On injected client tokens.
 */

.orDiv {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px 0;
  color: var(--text-tertiary);
  font-size: 11px;
}
.orDiv::before,
.orDiv::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--border-subtle);
}

.expressSlot {
  margin-bottom: 4px;
}
/* The wallet button waits while the number to call is asked for, as Confirm & pay does. */
.expressWaiting {
  opacity: 0.5;
  pointer-events: none;
}

/* Host for the reveal: the skeleton holds the layout while the Element renders
   hidden on top, so the swap at onReady is shift-free. */
.elementsHost {
  position: relative;
}
.elementsHidden {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  pointer-events: none;
}

/* Loading skeleton — echoes the whole payment surface (wallet button + "or pay with
   card" divider + the single Card accordion row; Link disabled account-side, so no
   Bank row) on the SourceRow recipe (--bg-inset fill, --border-soft hairline, 14px
   radius) so the placeholder reads as the same family and the surface reveals in one
   shift-free step. */
.skeleton {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.skelWallet {
  height: 48px;
  border-radius: 14px;
  background: var(--bg-inset);
  border: 1px solid var(--border-soft);
  animation: cardSkelPulse 1.4s ease-in-out infinite;
}
.skelDivider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 4px 0;
}
.skelDivider::before,
.skelDivider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--border-subtle);
}
.skelDividerBar {
  width: 84px;
  height: 9px;
  border-radius: 5px;
  background: var(--text-muted);
  flex-shrink: 0;
}
.skelRow {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px 13px;
  border-radius: 14px;
  background: var(--bg-inset);
  border: 1px solid var(--border-soft);
  animation: cardSkelPulse 1.4s ease-in-out infinite;
}
.skelRadio {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--text-muted);
  flex-shrink: 0;
}
.skelBar {
  height: 11px;
  width: 42%;
  border-radius: 6px;
  background: var(--text-muted);
}

@keyframes cardSkelPulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.55;
  }
}

/* inline intent error (post-retry IN_PROGRESS, PRICE_MISSING, generic) — themed
   banner. PAYMENT_WINDOW_TOO_CLOSE no longer lands here: CWR 2.6 bubbles it to the
   page-level S7 expired state. */
.intentError {
  padding: 12px 13px;
  background: rgba(var(--accent-rgb), 0.1);
  border: 1px solid rgba(var(--accent-rgb), 0.3);
  border-radius: 14px;
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.5;
}

.intentErrorTitle {
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 2px;
}
